import { TABLA_CAMIONES_LISTOS_PARA_BRUTO } from '../../../../../../config/tables'
import { COLUMNS_CAMIONES_LISTOS_PARA_BRUTO, COLUMNS_CAMIONES_LISTOS_PARA_BRUTO_TO_PRINT } from './constantesCamionesListosParaBruto'
import { TablaCamionesListosParaBrutoService } from '../servicio/tabla_camiones_listos_para_bruto'
import { pdfCustomToolbarGenerator } from '../../../../../../models/tools/generarPdf'

export function actualizarDatosParaMuiTable (filtroInicial = null) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CAMIONES_LISTOS_PARA_BRUTO
    })
    TablaCamionesListosParaBrutoService.getDataCamionesListosParaBruto().then(callback)
    function callback (result) {
      const data = []
      result.forEach(d => { data.push({ ...d, cartadeporte: d.numero }) })
      const customToolbar = pdfCustomToolbarGenerator(
        'Camiones listos para bruto',
        data,
        COLUMNS_CAMIONES_LISTOS_PARA_BRUTO_TO_PRINT,
        'landscape'
      )
      const textRowCount = 'Total de camiones: '
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_CAMIONES_LISTOS_PARA_BRUTO,
          data: data,
          title: `Camiones listos para bruto`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar,
            print: false,
            pagination: false,
            tableBodyMaxHeight: '450px',
            filtroInicial: filtroInicial,
            showRowCount: true,
            textRowCount
          }
        },
        id: TABLA_CAMIONES_LISTOS_PARA_BRUTO
      })
    }
  }
}
